export const ConversationsTypes = Object.freeze({
	FREE_TIER: 'FREE_TIER',
	REGULAR: 'REGULAR',
});

export const ConversationsCategories = Object.freeze({
	SERVICE: 'SERVICE',
	MARKETING: 'MARKETING',
	UTILITY: 'UTILITY',
	ADS: 'ADS',
});
